import type { CheckProductShippabilityInput } from '@/lib/types/shipping';
import type { ProcessedShippingEligibility } from '@/lib/types/shippingEligibilityState';
import { normalizeStateCode } from '@/lib/functions/normalizeStateCode';
import { checkTypeMatch } from '@/lib/functions/typeMatching';

export type ProductShippabilityResult = boolean | 'loading';

export const checkProductShippability = (
  input: CheckProductShippabilityInput,
  eligibility: ProcessedShippingEligibility | null,
  isLoading: boolean,
): ProductShippabilityResult => {
  if (isLoading) {
    return 'loading';
  }

  if (!eligibility) {
    return 'loading';
  }

  const { excludedTypes, excludedClassCodes, excludedStates, hasBeenProcessed } = eligibility;
  const { productType, classId, provinceCode } = input;
  const normalizedState = normalizeStateCode(provinceCode);

  if (hasBeenProcessed && eligibility.availableMethods.length === 0) {
    return false;
  }

  if (productType && checkTypeMatch(productType, excludedTypes)) {
    return false;
  }

  if (classId && excludedClassCodes.includes(String(classId))) {
    return false;
  }

  if (normalizedState && excludedStates.includes(normalizedState)) {
    return false;
  }

  return true;
};
